import React, { useContext } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PATHS from "../../../../constants/paths";

import {
  IconStyled,
  ButtonOption,
  Logo,
  OffCanvasHeader,
  NavLink,
  ButtonOption2,
} from "./styled";
import { AuthContainer } from "../../../security/auth/auth.container";

import { Can, AbilityContext } from "../../../security/permissions/Can";
import { USER_PERMISSIONS } from "../../../security/permissions/rolesPermission";
import { checkBootstrapSizeBreak } from "../../../../utils/device/checkDevice";

const Sidebar = (props) => {
  const auth = AuthContainer.useContainer();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { offCanvas } = props;
  const context = useContext(AbilityContext);
  const deviceSize = checkBootstrapSizeBreak();

  const logout = async () => {
    auth.logout();
    openCenteredPopup(
      `https://login.microsoftonline.com/99dbb24d-723f-44f0-b082-24b8ce4784d4/oauth2/logout`,
      `logout azureAd`,
      150,
      150
    );
  };

  const handlerSelectOption = async (key) => {
    switch (key) {
      case "home":
        navigate(PATHS.HOME);
        break;

      case "close_session":
        logout();
        break;

      /* GENERATOR_INJECT_GO_TO */
      case "viewWorkingPart":
        navigate(PATHS.WORKING_PART_LIST);
        break;
      case "viewAllWorkingPart":
        navigate(PATHS.ALL_WORKING_PART_LIST);
        break;
      case "myWorkingPart":
        navigate(PATHS.MY_WORKING_PART_LIST);
        break;

      case "viewCode":
        navigate(PATHS.CODE_LIST);
        break;
      case "viewSector":
        navigate(PATHS.SECTOR_LIST);
        break;
      case "viewLocation":
        navigate(PATHS.LOCATION_LIST);
        break;
      case "viewArticle":
        navigate(PATHS.ARTICLE_LIST);
        break;
      case "viewTask":
        navigate(PATHS.TASK_LIST);
        break;
      case "viewBatch":
        navigate(PATHS.BATCH_LIST);
        break;
      case "viewVariety":
        navigate(PATHS.VARIETY_LIST);
        break;
      case "users":
        navigate(PATHS.USERS);
        break;
      case "merma":
        navigate(PATHS.MERMA_PART_LIST);
        break;
      case "reports":
        navigate(PATHS.REPORTS);
        break;

      case "viewVivero":
        navigate(PATHS.VIVERO_LIST);
        break;

      default:
        break;
    }
  };

  return (
    <>
      <ul className="nav flex-column text-white w-100">
        {offCanvas && (
          <OffCanvasHeader className="offcanvas-header">
            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </OffCanvasHeader>
        )}
        <a
          href={`${process.env.REACT_APP_PROTOCOL}://${
            process.env.REACT_APP_HOST
          }${
            process.env.REACT_APP_PORT ? `:${process.env.REACT_APP_PORT}` : ""
          }/client/home`}
          className="nav-link-logo text-center mb-4 mt-3"
        >
          <Logo
            src={`/assets/themes/${process.env.REACT_APP_THEME}/images/logo.png`}
            alt="logo"
            className="logo"
            offCanvas={offCanvas}
          />
        </a>
        <Can do={USER_PERMISSIONS.INIT}>
          <NavLink href="#" className="selectable nav-link ">
            {/* <span className="mx-2"> */}
            <ButtonOption
              $active={true}
              data-bs-dismiss={deviceSize < 3 ? "offcanvas" : ""}
              onClick={() => {
                handlerSelectOption("home");
              }}
            >
              <IconStyled className="fa-solid fa-gauge" />
              {t("home")}
            </ButtonOption>

            {/* </span> */}
          </NavLink>
        </Can>
        <NavLink href="#" className="selectable nav-link ">
          <ButtonOption
            $active={true}
            data-bs-dismiss={deviceSize < 3 ? "offcanvas" : ""}
            onClick={() => {
              handlerSelectOption("myWorkingPart");
            }}
          >
            <IconStyled className="fa-solid fa-calendar-day" />
            {t("myWorkingPart")}
          </ButtonOption>
        </NavLink>
        <Can do={USER_PERMISSIONS.LIST_ALL_WORKING_PART}>
          <NavLink href="#" className="selectable nav-link ">
            <ButtonOption
              $active={true}
              data-bs-dismiss={deviceSize < 3 ? "offcanvas" : ""}
              onClick={() => {
                handlerSelectOption("viewWorkingPart");
              }}
            >
              <IconStyled className="fa-solid fa-calendar-day" />
              {t("workingPart")}
            </ButtonOption>
          </NavLink>
        </Can>
        <Can do={USER_PERMISSIONS.LIST_ALL_WORKING_PART}>
          <NavLink href="#" className="selectable nav-link ">
            <ButtonOption
              $active={true}
              data-bs-dismiss={deviceSize < 3 ? "offcanvas" : ""}
              onClick={() => {
                handlerSelectOption("viewAllWorkingPart");
              }}
            >
              <IconStyled className="fa-solid fa-calendar-week" />
              {t("allWorkingPart")}
            </ButtonOption>
          </NavLink>
        </Can>
        <Can do={USER_PERMISSIONS.LIST_MERMA}>
          <NavLink href="#" className="selectable nav-link ">
            <ButtonOption
              $active={true}
              data-bs-dismiss={deviceSize < 3 ? "offcanvas" : ""}
              onClick={() => {
                handlerSelectOption("merma");
              }}
            >
              <IconStyled className="fa-solid fa-calendar-xmark" />
              {t("mermaPart")}
            </ButtonOption>
          </NavLink>
        </Can>
        <Can do={USER_PERMISSIONS.LIST_VIVERO}>
          <NavLink href="#" className="selectable nav-link ">
            <ButtonOption
              $active={true}
              data-bs-dismiss={deviceSize < 3 ? "offcanvas" : ""}
              onClick={() => {
                handlerSelectOption("viewVivero");
              }}
            >
              <IconStyled className="fa-solid fa-house-flag" />
              {t("menu.vivero")}
            </ButtonOption>
          </NavLink>
        </Can>
        <Can do={USER_PERMISSIONS.LIST_VARIETY}>
          <NavLink href="#" className="selectable nav-link ">
            <ButtonOption
              $active={true}
              data-bs-dismiss={deviceSize < 3 ? "offcanvas" : ""}
              onClick={() => {
                handlerSelectOption("viewVariety");
              }}
            >
              <IconStyled className="fa-brands fa-pagelines" />
              {t("menu.variety")}
            </ButtonOption>
          </NavLink>
        </Can>
        <Can do={USER_PERMISSIONS.LIST_BATCH}>
          <NavLink href="#" className="selectable nav-link ">
            <ButtonOption
              $active={true}
              data-bs-dismiss={deviceSize < 3 ? "offcanvas" : ""}
              onClick={() => {
                handlerSelectOption("viewBatch");
              }}
            >
              <IconStyled className="fa-solid fa-spell-check" />
              {t("menu.batch")}
            </ButtonOption>
          </NavLink>
        </Can>
        <Can do={USER_PERMISSIONS.LIST_TASK}>
          <NavLink href="#" className="selectable nav-link ">
            <ButtonOption
              $active={true}
              data-bs-dismiss={deviceSize < 3 ? "offcanvas" : ""}
              onClick={() => {
                handlerSelectOption("viewTask");
              }}
            >
              <IconStyled className="fa-solid fa-list-check" />
              {t("menu.task")}
            </ButtonOption>
          </NavLink>
        </Can>
        <Can do={USER_PERMISSIONS.LIST_ARTICLE}>
          <NavLink href="#" className="selectable nav-link ">
            <ButtonOption
              $active={true}
              data-bs-dismiss={deviceSize < 3 ? "offcanvas" : ""}
              onClick={() => {
                handlerSelectOption("viewArticle");
              }}
            >
              <IconStyled className="fa-solid fa-list" />
              {t("menu.article")}
            </ButtonOption>
          </NavLink>
        </Can>
        <Can do={USER_PERMISSIONS.LIST_LOCATION}>
          <NavLink href="#" className="selectable nav-link ">
            <ButtonOption
              $active={true}
              data-bs-dismiss={deviceSize < 3 ? "offcanvas" : ""}
              onClick={() => {
                handlerSelectOption("viewLocation");
              }}
            >
              <IconStyled className="fa-solid fa-location-dot" />
              {t("menu.location")}
            </ButtonOption>
          </NavLink>
        </Can>
        <Can do={USER_PERMISSIONS.LIST_SECTOR}>
          <NavLink href="#" className="selectable nav-link ">
            <ButtonOption
              $active={true}
              data-bs-dismiss={deviceSize < 3 ? "offcanvas" : ""}
              onClick={() => {
                handlerSelectOption("viewSector");
              }}
            >
              <IconStyled className="fa-solid fa-chart-pie" />
              {t("menu.sector")}
            </ButtonOption>
          </NavLink>
        </Can>
        <Can do={USER_PERMISSIONS.LIST_CODE}>
          <NavLink href="#" className="selectable nav-link ">
            <ButtonOption
              $active={true}
              data-bs-dismiss={deviceSize < 3 ? "offcanvas" : ""}
              onClick={() => {
                handlerSelectOption("viewCode");
              }}
            >
              <IconStyled className="fa-solid fa-qrcode" />
              {t("menu.code")}
            </ButtonOption>
          </NavLink>
        </Can>
        <Can do={USER_PERMISSIONS.LIST_CODE}>
          <NavLink href="#" className="selectable nav-link ">
            <ButtonOption
              $active={true}
              data-bs-dismiss={deviceSize < 3 ? "offcanvas" : ""}
              onClick={() => {
                handlerSelectOption("users");
              }}
            >
              <IconStyled className="fa-solid fa-users" />
              {t("menu.users")}
            </ButtonOption>
          </NavLink>
        </Can>
        <Can do={USER_PERMISSIONS.LIST_CODE}>
          <NavLink href="#" className="selectable nav-link ">
            <ButtonOption
              $active={true}
              data-bs-dismiss={deviceSize < 3 ? "offcanvas" : ""}
              onClick={() => {
                handlerSelectOption("reports");
              }}
            >
              <IconStyled className="fa-solid fa-file-excel" />
              {t("menu.reports")}
            </ButtonOption>
          </NavLink>
        </Can>
        {/* GENERATOR_INJECT_MENU */}
      </ul>
      <span href="#" className="nav-link w-100 mb-2">
        <ButtonOption2
          $active={true}
          onClick={() => {
            handlerSelectOption("close_session");
          }}
        >
          <IconStyled className="fas fa-power-off" />
          {t("close_session")}
        </ButtonOption2>
      </span>
    </>
  );
};

// Sidebar.contextType = AbilityContext;

Sidebar.propTypes = {
  nickname: PropTypes.string,
  offCanvas: PropTypes.bool,
};

export default Sidebar;

export const openCenteredPopup = (url, title, w, h) => {
  // Fixes dual-screen position                             Most browsers      Firefox
  const dualScreenLeft =
    window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop =
    window.screenTop !== undefined ? window.screenTop : window.screenY;

  const width = window.innerWidth
    ? window.innerWidth
    : document.documentElement.clientWidth
    ? document.documentElement.clientWidth
    : window.screen.width;
  const height = window.innerHeight
    ? window.innerHeight
    : document.documentElement.clientHeight
    ? document.documentElement.clientHeight
    : window.screen.height;

  const systemZoom = width / window.screen.availWidth;
  const left = (width - w) / 2 / systemZoom + dualScreenLeft;
  const top = (height - h) / 2 / systemZoom + dualScreenTop;
  const newWindow = window.open(
    url,
    title,
    `
      scrollbars=no,
      toolbar=no,
      location=no,
      directories=no,
      status=no,
      menubar=no,
      resizable=no,
      copyhistory=no,
      width=${w / systemZoom}, 
      height=${h / systemZoom}, 
      top=${top}, 
      left=${left}
      `
  );

  newWindow?.focus();

  setTimeout(() => {
    newWindow.close();
  }, 5000);
};
